<template>
    <div>
    <section style="background-color: #fff; padding: 40px;">
        <div style="text-align: center;">
        <h2 style="margin-bottom: 0; font-size: 40px; font-weight: bold;">{{ block.title }}</h2>
        <img src="/img/teal-line.svg" class="mb20 mt20"/>
    </div>
    <div class="fort-body">
        <div v-html="block.body">

</div>
       
       
    </div>
</section>

   <divider v-if="block.BottomDivider" />
  </div>
  </template>
  
  <script>
  import Divider from "@/components/FortBuilder/Divider.vue";

  export default {
    name: "AbovePar",
    data() {
        return {
        };
    },
    props: {
      block: {
        type: Object,
        required: true,
      },
    },
    components: {
      Divider,
    },
    methods: {
      
    },
  };
  </script>
  
  <style scoped>

</style>















